import styles from './project.module.css';
import { AiFillGithub } from 'react-icons/ai';

export default function Project({ available, name, children, stack, src, alt, color, url }) {
  return (
    <div className={styles.projectContaienr}>
      <div className={styles.metaData}>
        <div>
          <div className={styles.circle} style={{ backgroundColor: color }}></div>
        </div>
        <div className={styles.text}>
          <h2 style={{ color }} className={styles.title}>
            {name}
          </h2>
          <p style={{ color }} className={styles.description}>
            {children}
          </p>
          <div className={styles.stackContainer}>{stack}</div>
          {available && (
            <div>
              <a
                target="blank"
                href={url}
                style={{ backgroundColor: color }}
                className={styles.viewProject}
              >
                <AiFillGithub />
                <span>Ver proyecto</span>
              </a>
            </div>
          )}
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img src={src} alt={alt} />
      </div>
    </div>
  );
}
